import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(id) {
    return await requestWrapper(null, 'GET', `/doc_sections/${id}`);
  },
  async create(section) {
    return await requestWrapper(null, 'POST', '/doc_sections', null, section);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/document_sections/${id}`);
  },
  async update(section) {
    return await requestWrapper(null, 'PUT', `/doc_sections/${section.id}`, null, section);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/doc_sections/${id}`);
  },
};
